/** Strip query/hash so CDN cache-busters (`?v=`) don't defeat image dedupe. */
export function urlPathname(url?: unknown): string {
  if (!url) return ""
  if (typeof url === "string") {
    return url.split(/[?#]/)[0]
  }
  if (typeof url === "object" && url !== null) {
    const obj = url as Record<string, any>
    if (typeof obj.url === "string") {
      return obj.url.split(/[?#]/)[0]
    }
    if (obj.large && typeof obj.large.url === "string") {
      return obj.large.url.split(/[?#]/)[0]
    }
    if (obj.small && typeof obj.small.url === "string") {
      return obj.small.url.split(/[?#]/)[0]
    }
  }
  return ""
}

export function uniqueBy<T>(items: T[], key: (item: T) => string): T[] {
  const seen = new Set<string>()
  return items.filter(item => {
    const k = key(item)
    if (seen.has(k)) return false
    seen.add(k)
    return true
  })
}
